<template>
  <div class="switch-wrap">
    <button
      ref="FLTTab"
      :class="{ active: activeTab === 'FLT' }"
      class="switch"
      tabindex="0"
      @click="switchTab('FLT')"
    >
      {{ $t(`reusable.flight`) }}
    </button>
    <button
      ref="HTLTab"
      :class="{ active: activeTab === 'HTL' }"
      class="switch"
      tabindex="0"
      @click="switchTab('HTL')"
    >
      {{ $t(`indexTabs.eHorizon.htlTabLabel`) }}
    </button>
    <a
      class="switch booking"
      target="_blank"
      :href="hotelURL"
    >
      <img
        src="~/assets/svg/booking.svg"
        height="24"
        width="110"
        alt="booking-com-logo"
      />
    </a>
    <a
      class="switch sixt"
      target="_blank"
      :href="sixtURL"
    >
      <img
        src="~/assets/svg/sixt.svg"
        height="24"
        width="42"
        alt="sixt-logo"
      />
    </a>
    <a
      class="switch rentalcars"
      target="_blank"
      :href="rentalcarsURL"
    >
      <img
        src="~/assets/svg/rentalcars.svg"
        height="24"
        width="120"
        alt="rentalcars-logo"
      />
    </a>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  const CUSTOM_PATHS = {
    hotel: 'https://www.booking.com/?aid=381407&label=indexpage_search-link-381407-click',
    sixt: {
      en: 'https://www.sixt.com/partners/airbaltic/?utm_source=Airline&utm_medium=BT_flightsearch&utm_campaign=Standard&utm_id=airline-airbaltic-club-main-en-us&utm_term=Airbaltic_Club',
      lv: 'https://www.sixt.lv/partners/airbaltic/?utm_source=Airline&utm_medium=BT_flightsearch&utm_campaign=Standard&utm_id=airline-airbaltic-club-main-lv-lv&utm_term=Airbaltic_Club',
      ru: 'https://www.sixt.com/partners/airbaltic/?utm_source=Airline&utm_medium=BT_flightsearch&utm_campaign=Standard&utm_id=airline-airbaltic-club-main-en-us&utm_term=Airbaltic_Club',
      lt: 'https://www.sixt.lt/partners/airbaltic/?utm_source=Airline&utm_medium=BT_flightsearch&utm_campaign=Standard&utm_id=airline-airbaltic-club-main-lt-lt&utm_term=Airbaltic_Club',
      et: 'https://www.sixt.ee/partners/airbaltic/?utm_source=Airline&utm_medium=BT_flightsearch&utm_campaign=Standard&utm_id=airline-airbaltic-club-main-ee-ee&utm_term=Airbaltic_Club',
      fi: 'https://www.sixt.fi/partners/airbaltic/?utm_source=Airline&utm_medium=BT_flightsearch&utm_campaign=Standard&utm_id=airline-airbaltic-club-main-fi-fi&utm_term=Airbaltic_Club ',
      de: 'https://www.sixt.de/partners/airbaltic/?utm_source=Airline&utm_medium=BT_flightsearch&utm_campaign=Standard&utm_id=airline-airbaltic-club-main-de-de&utm_term=Airbaltic_Club'
    },
    rentalcars: `https://www.rentalcars.com/$lang/?affiliateCode=airbaltic&adplat=indexpage&adcamp=link`
  }

  export default {
    computed: {
      ...mapState('indexTabs', ['activeTab', 'tabAutoFocus']),
      hotelURL() {
        return CUSTOM_PATHS.hotel
      },
      sixtURL() {
        return CUSTOM_PATHS.sixt[this.$i18n.locale()]
      },
      rentalcarsURL() {
        return CUSTOM_PATHS.rentalcars.replace('$lang', this.$i18n.locale())
      }
    },
    mounted() {
      if (this.tabAutoFocus) {
        this.focusTab()
      }
    },
    methods: {
      focusTab() {
        if (!this.activeTab) return

        const tab = this.activeTab
        this.$nextTick(() => {
          const refName = `${tab}Tab`
          const tabRef = this.$refs[refName]
          if (tabRef) {
            tabRef.focus()
          }
        })
      },
      switchTab(tab) {
        this.$store.commit('indexTabs/setActiveTab', tab)
        this.$store.commit('indexTabs/enableTabAutoFocus')
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .switch-wrap {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding: 24px 16px 12px 16px;

    button {
      overflow: unset;
      flex: 1;
    }

    @include bp-mf-tablet {
      padding-left: 0;
      padding-top: 0;
    }

    @include bp-mf-desktop {
      overflow: unset;
      margin-bottom: 24px;
      padding: 0;
    }

    .switch {
      display: flex;
      align-items: center;
      font-size: em(14);
      font-weight: 500;
      color: $blue-dark;
      padding: 6px 16px;
      background: white;
      border-radius: 16px;
      line-height: 20px;
      cursor: pointer;
      flex-shrink: 0;
      text-decoration: none;
      justify-content: center;
      height: 32px;

      @include outline-focus;

      &:focus-visible {
        border-radius: 16px;
      }

      &.active {
        background: $green-base;
      }

      @media only screen and (max-width: 362px) {
        padding: 6px 18px;
      }
    }
  }
</style>
